import { ChangelogView } from "./_components";

export default function ChangelogPage() {
  return <ChangelogView />;
}
